import React from "react";
import { Typography, Box } from "@mui/material";
import { MERCHANT_LEGAL } from "../config/merchantLegalConfig";
import MerchantLegalNotice from "./MerchantLegalNotice";

/** Customer support + registered seller block for policy page footers. */
const PolicyContactSection = ({ intro, sx = {} }) => (
  <>
    <Typography variant="body1" paragraph>
      {intro}
    </Typography>
    <Box sx={{ pl: 2, ...sx }}>
      <Typography variant="body1" component="div" sx={{ mb: 2 }}>
        <strong>Registered office / shipping address</strong>
        <br />
        {MERCHANT_LEGAL.addressLines.join(", ")}
      </Typography>
      <MerchantLegalNotice variant="body1" headingVariant="subtitle1" />
    </Box>
  </>
);

export default PolicyContactSection;
